<template>
  <div :style="stickyStyle">
    <template v-if="objectType === 'instance'">
      <div class="mb-6">
        <v-progress-circular
          :rotate="360"
          :size="60"
          :width="6"
          :value="instanceEntriesCheckedProgress"
          color="primary"
        >
          <span class="text-subtitle-2">
            {{ instanceEntriesCheckedNumber }}/{{ instanceEntriesNumber }}
          </span>
          <!-- <span class="text-subtitle-2"> {{ Math.ceil(instanceEntriesCheckedProgress) }} </span> -->
        </v-progress-circular>
        <span class="text-subtitle-2 pl-2">
          Checked
        </span>
      </div>
    </template>

    <!-- :class="{ 'mt-8': objectType === 'instance' }" class="mb-8" -->
    <div v-if="showAvatar" class="my-8">
      <p class="text-subtitle-2 mb-1">Currently on this {{ $t(objectType) }}</p>
      <sl-avatar v-for="user in object.currentlyOnUsers" :key="user.id" :user="user" class="ma-1" />
    </div>

    <div>
      <p>
        <span class="text-subtitle-2">
          Created by
          <sl-text-truncated :text="object.creator.firstName" :lengthMax="nameCharsShownMax" />
          <sl-text-truncated :text="object.creator.lastName" :lengthMax="nameCharsShownMax" />
        </span>
        <br />
        <span class="text-subtitle-2 font-weight-regular">
          on <sl-time :time="object.createdAt"></sl-time>
        </span>
      </p>

      <template v-if="objectType === 'master'">
        <p v-if="object.lastInstance">
          <span class="text-subtitle-2">
            Last checklist by
            <sl-text-truncated
              :text="object.lastInstance.creator.firstName"
              :lengthMax="nameCharsShownMax"
            />
            <sl-text-truncated
              :text="object.lastInstance.creator.lastName"
              :lengthMax="nameCharsShownMax"
            />
          </span>
          <br />
          <span class="text-subtitle-2 font-weight-regular">
            on <sl-time :time="object.lastInstance.createdAt"></sl-time>
          </span>
        </p>
        <p v-else class="text-body-2">No checklists yet</p>
        <!-- <p>
        Last changed by {{ object.lastEntryUpdate.user.firstName }}
        {{ object.lastEntryUpdate.user.lastName }}
        on <sl-time :time="object.lastEntryUpdate.time"></sl-time>
      </p> -->
      </template>

      <template v-else-if="objectType === 'instance'">
        <p v-if="object.archived">
          <span class="text-subtitle-2">
            Archived by
            <sl-text-truncated :text="object.archivedBy.firstName" :lengthMax="nameCharsShownMax" />
            <sl-text-truncated :text="object.archivedBy.lastName" :lengthMax="nameCharsShownMax" />
          </span>
          <br />
          <span class="text-subtitle-2 font-weight-regular">
            on <sl-time :time="object.archivedAt"></sl-time>
          </span>
        </p>
        <p v-else>
          <span class="text-subtitle-2">
            Last change by
            <sl-text-truncated
              :text="object.lastEntryUpdate.user.firstName"
              :lengthMax="nameCharsShownMax"
            />
            <sl-text-truncated
              :text="object.lastEntryUpdate.user.lastName"
              :lengthMax="nameCharsShownMax"
            />
          </span>
          <br />
          <span class="text-subtitle-2 font-weight-regular">
            on <sl-time :time="object.lastEntryUpdate.time"></sl-time>
          </span>
        </p>
      </template>
    </div>
  </div>
</template>

<script>
import SlAvatar from '@/components/SlAvatar'
import SlTime from '@/components/SlTime'
import SlTextTruncated from '@/components/SlTextTruncated'

export default {
  components: {
    SlAvatar,
    SlTime,
    SlTextTruncated,
  },

  props: {
    object: {
      type: Object,
      required: true,
    },
    objectType: {
      type: String,
      required: true,
      validator: function(value) {
        // The value must match one of these strings
        return ['master', 'instance'].indexOf(value) !== -1
      },
    },
    showAvatar: {
      type: Boolean,
      required: false,
      default: false,
    },
    sticky: {
      type: Number,
      required: false,
      default: -1,
    },
  },

  data: () => ({
    nameCharsShownMax: 16,
    //
  }),

  computed: {
    instanceEntriesCheckedAll() {
      return this.instanceEntriesCheckedNumber === this.instanceEntriesNumber
    },
    instanceEntriesNumber() {
      return this.object.clInstanceEntries?.length
    },
    instanceEntriesCheckedNumber() {
      const entryIsChecked = entry => entry.checked
      return this.object.clInstanceEntries?.filter(entryIsChecked).length
    },
    instanceEntriesCheckedProgress() {
      return (this.instanceEntriesCheckedNumber / this.instanceEntriesNumber) * 100
    },
    stickyStyle: function() {
      if (this.sticky > 0) {
        return 'position:sticky; top: ' + this.sticky + 'px; '
      } else {
        return ''
      }
    },
  },

  methods: {
    //
  },
}
</script>

<style scoped></style>
